var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXShareMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_7262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7378 26.8107L18.6306 31.6577C17.1709 33.3793 15.7106 35.1006 14.2495 36.8216C14.1866 36.8941 14.0836 36.9811 13.9985 36.9833C13.36 36.9971 12.7222 36.9906 12 36.9906C15.3006 33.0935 18.5476 29.2596 21.8025 25.4177L12.0272 11.0102H12.5513C14.6964 11.0102 16.8415 11.0203 18.9867 11C19.3106 11 19.4743 11.1218 19.6402 11.3677C21.6705 14.3737 23.7059 17.3773 25.7467 20.3785C25.786 20.4365 25.831 20.4909 25.8983 20.5801C26.3988 19.9906 26.8886 19.4199 27.3741 18.8463C29.4935 16.3454 31.6112 13.8434 33.7273 11.3401C33.9289 11.1008 34.1384 10.9898 34.4566 11.0065C34.9872 11.0334 35.5206 11.0138 36.1276 11.0138L26.8321 21.9797L37 36.9579C36.872 36.9724 36.7855 36.9898 36.699 36.9898C34.4473 36.9898 32.1942 36.9848 29.9433 37C29.6737 37 29.5679 36.8608 29.4427 36.678C27.2862 33.4984 25.1279 30.3174 22.968 27.1349C22.9015 27.037 22.8307 26.942 22.7378 26.8107Z",
    fill: "#1593D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_7262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXShareMa);
export default __webpack_public_path__ + "static/media/x_shareMA.b9908f46c9b77f5f597b9c80dc3a0587.svg";
export { ForwardRef as ReactComponent };